export const chartColors = {
    // '1/2"': '#DEC591',    
    // '3/4"': '#AEC7A6',  
    // '1"': '#E9B9AA',  
    // '1-1/4"': '#D98481', 
    // '1-1/2"': '#F892B5',
    // '2"': '#C0BAA2',
    // '2-1/2"': '#G3E3A2',
    // '3"': '#E58787',
    // '4"': '#HCB9C0',
    // '12"': '#I9B9AA',
    // 'NC"': '#F892B5',
    'Astral Team': "#DEC591",
    'AstralTeam': "#DEC591",
    'Distributor': '#AEC7A6',
    'Dealer': '#D98481',
    'Other': '#7892B5',
    'Retailer': '#F892B5',
    'Stockiest': '#E9B9AA',
    'Counterfeit': '#FE3838',
    'Cross Selling': '#FFA500',
    'Genuine': '#19BB4D',
};

export const getSizeColor = (sizeName, sizeData) => {
    
    if (!sizeData || !sizeName) return '#000000'; // default color if no data or size name

    // find color from sizeData based on sizeName
    const sizeItem = sizeData.find(item => item.size === sizeName);
 
    if (sizeItem) {
        return sizeItem.color || '#000000';
    }
    
    return '#000000'; // default color if no match found
};

const isVisibleColor = (color) => {
    if (!color || typeof color !== 'string') return false;
    const normalized = color.toLowerCase().trim();
    return normalized !== '#ffffff' && normalized !== '#fff' && normalized !== 'white';
};

export const getUserRoleColor = (roleName, userRoleList) => {
    if (!userRoleList || !roleName) return chartColors[roleName] || '#000000';

    const roleItem = userRoleList.find(item => item.name === roleName);

    if (roleItem && isVisibleColor(roleItem.color)) {
        return roleItem.color;
    }

    return chartColors[roleName] || '#000000';
}